import { authClient, useSession } from "@repo/db"
import { useCallback } from "react"

export function ImpersonationBanner() {
  const { data: session } = useSession()

  const isImpersonating = !!(session as Record<string, unknown> | null)?.impersonatedBy

  const stopImpersonating = useCallback(async () => {
    await authClient.admin.stopImpersonating()
    window.location.reload()
  }, [])

  if (!isImpersonating) return null

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-destructive text-destructive-foreground px-4 py-1.5 text-center text-sm font-medium">
      You are impersonating a user.{" "}
      <button onClick={stopImpersonating} className="underline underline-offset-2 hover:opacity-80">
        Stop impersonating
      </button>
    </div>
  )
}
